import React, { useState, createContext, ReactNode } from "react";

export interface ProviderContext {
  setNewPDPLayout: (newPDPLayout: boolean) => void;
  newPDPLayout: boolean;
  children?: ReactNode;
}
export const ProductConfiguratorContext = createContext<ProviderContext>({
  setNewPDPLayout: () => {},
  newPDPLayout: false
});

const ProductConfiguratorProvider = ({ children }) => {
  const [newPDPLayout, setNewPDPLayout] = useState<boolean>(false);

  return (
    <ProductConfiguratorContext.Provider
      value={{
        newPDPLayout,
        setNewPDPLayout
      }}
    >
      {children}
    </ProductConfiguratorContext.Provider>
  );
};

export default ProductConfiguratorProvider;
